import React from 'react'

import { Ring } from './styles'

const VibeNeonRing = props => {
    return <Ring {...props} className="vibe-neon-ring" />
}

export default VibeNeonRing
